import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import Table from '../../Components/Table'
import ProjectCollection from '../../State/Collections/ProjectCollection'
import ProjectNoteCollection from '../../State/Collections/ProjectNoteCollection'
import { canEditProjectNotes } from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import { PhaseSelector } from '../../Components/Selector'

const noteColumns = [
    {
        id: 'date',
        label: 'Date',
        width: 20,
        type: 'date',
        editable: (r) => canEditProjectNotes(SessionStore.user, r.project),
        value: (r) => r.date,
        onChange: (r) => (v) => r.update({ date: v }),
    },
    {
        label: 'Phase',
        width: 20,
        type: 'phase',
        editable: (r) => canEditProjectNotes(SessionStore.user, r.project),
        value: (p) => p.phase,
        onChange: (r) => (v) => r.update({ phaseId: v.id }),
        component: ({ value, onChange, stores, editable }) => {
            const project = stores.row.rowObject.project
            return editable ? (
                <PhaseSelector
                    options={project.phases}
                    {...{ selectedPhase: value, onChange }}
                    variant="secondary"
                    className="!border-none h-full !rounded-none"
                />
            ) : (
                value?.title || 'No Phase'
            )
        },
    },
    {
        label: 'Note',
        width: 60,
        type: 'textarea',
        editable: (r) => canEditProjectNotes(SessionStore.user, r.project),
        value: (p) => p.description,
        onChange: (r) => (v) => r.update({ description: v }),
    },
    {
        label: '',
        width: 4,
        type: 'button',
        permissions: (r) => canEditProjectNotes(SessionStore.user, r.project),
        editable: (r) => canEditProjectNotes(SessionStore.user, r.project),
        value: (p) => <i className="fa fa-times" style={{ marginRight: 0 }} />,
        onClick: (r) => () => {
            r.update({ deletedAt: new Date() })
        },
    },
]

export default observer(({ id }) => {
    const project = ProjectCollection.projectsById[id]
    useEffect(() => {
        ;(project?.notes || []).forEach((cli, i) => (cli.position = i))
    }, [project])
    if (!project) return null
    const [rows, setRows] = useState(
        project.notes.sort((a, b) => b?.date?.getTime() - a?.date?.getTime())
    )
    useEffect(() => {
        setRows(
            project.notes.sort(
                (a, b) => b?.date?.getTime() - a?.date?.getTime()
            )
        )
    }, [project.id])
    return (
        <div>
            {canEditProjectNotes(SessionStore.user, project) ? (
                <button
                    className="btn btn-default plus-btn border-[#ccc]"
                    style={{ marginBottom: '2em' }}
                    onClick={() => {
                        const pn = ProjectNoteCollection.add(
                            {
                                projectId: project.id,
                                phaseId: project.rootPhase.id,
                                date: new Date(),
                            },
                            { trackUpdates: true }
                        )
                        pn.position = project.notes.length
                        setRows([pn, ...rows])
                    }}
                >
                    + Add Note
                </button>
            ) : null}
            <Table
                columns={noteColumns}
                rows={rows.filter((r) => !r.deletedAt)}
            />
        </div>
    )
})
